import { CsvPayload } from '../../common/models/CsvPayload';

export class InstanceSummary {
  constructor(
    private readonly instance: CsvPayload,
    private readonly issue: CsvPayload,
    private readonly calls: CsvPayload,
    private readonly operations: CsvPayload,
    private readonly locations: CsvPayload,
    private readonly hardCodedStringLocations: CsvPayload
  ) {}

  getInstance() {
    return this.instance;
  }

  getIssue() {
    return this.issue;
  }

  getCalls() {
    return this.calls;
  }

  getOperations() {
    return this.operations;
  }

  getLocations() {
    return this.locations;
  }

  getHardCodedStringLocations() {
    return this.hardCodedStringLocations;
  }
}
